import { getWindowOrThrow } from 'app/utils/env';
import { Component, ReactNode } from 'react';

interface IProps {
  children?: ReactNode;
  event: keyof WindowEventMap;
  handler: () => void;
}

export default class OnWindowEvent extends Component<IProps> {
  public componentDidMount() {
    getWindowOrThrow().addEventListener(this.props.event, this.eventListener, false);
  }

  public componentDidUpdate(prevProps: IProps) {
    // Check if event has changed.
    if (this.props.event !== prevProps.event) {
      getWindowOrThrow().removeEventListener(prevProps.event, this.eventListener, false);
      getWindowOrThrow().addEventListener(this.props.event, this.eventListener, false);
    }
  }

  public componentWillUnmount() {
    getWindowOrThrow().removeEventListener(this.props.event, this.eventListener, false);
  }

  public render() {
    return this.props.children || null;
  }

  private eventListener = () => {
    this.props.handler();
  };
}
